import React from 'react';

import Button from '../../../../components/global/Button';
import ContributeButton from '../../../../components/global/ContributeButton';
import { getAsset } from '../../../../util/assets';
import ArrowRight from '../../../../components/icons/ArrowRight';

const WebGalleryAlbumFolderNullState = () => {
  return (
    <div className="text-center my-3 web-gallery-header-container">
      <div className="web-gallery-null-state-copy">
        <img
          src={getAsset('/waldo-icon.svg')}
          className="grayscale-faded mb-1"
          width="40"
          alt="Waldo Icon"
        />
        <p className="text-extra-bold text-light">
          No photos have been uploaded yet.
        </p>
      </div>
      <div className="web-gallery-null-state-btn-container">
        <ContributeButton>
          {({ onClick }) => (
            <Button
              btnStyle="reset"
              className="web-gallery-null-state-btn"
              onClick={onClick}
            >
              <img
                src={getAsset('/album-cards-uploads.svg')}
                alt="Find my photos"
              />

              <div className="web-gallery-null-state-btn-action">
                <span>Upload Photos</span>
                <ArrowRight />
              </div>
            </Button>
          )}
        </ContributeButton>
      </div>
    </div>
  );
};

export { WebGalleryAlbumFolderNullState as WebGalleryAlbumFolderNullStateComponent };

export default WebGalleryAlbumFolderNullState;
